/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Storage, { StorageProxy } from 'common/lib/storage';

export default function lastOrganization(storage: StorageProxy = Storage) {
  const orgIdKey = 'idLastOrganization';
  const noOrgId = 'none';

  return {
    NO_ORGANIZATION: noOrgId,
    LAST_ORGANIZATION: orgIdKey,

    set(idOrganization: string): void {
      storage.set(orgIdKey, idOrganization ? idOrganization : noOrgId);
    },

    get(): string | null {
      const value = storage.get(orgIdKey);

      return typeof value === 'string' ? value : null;
    },
  };
}



// WEBPACK FOOTER //
// ./app/common/lib/util/last-organization.ts